<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'text', label: '점검자', value: '점검자' },
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <TableInspectMerge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="$t('예방 점검표')"
      contentBefore="•"
      v-model="form.inspectList"
      class="mt-28px"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검자: { required },
        점검일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        fileList: [],
        inspectList: [
          {
            content: "<span class='font-normal'>근로자에게 안전모, 안전대 등을 적정하게 지급하고 착용여부를 확인하였는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제32조)</span>",
            isChecked: "",
            title: "안전모, 안전대",
          },
          {
            content: "<span class='font-bold'>비계 : </span>" +
              "<span class='font-normal'>작업발판 구조 및 설치 상태가 적정한지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제56조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>비계 : </span>" +
              "<span class='font-normal'>작업발판 단부에 안전난간이 적정하게 설치되어 있는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제43조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>철골 : </span>" +
              "<span class='font-normal'>안전하게 이동할 수 있는 승강로가 적정하게 설치되어 있는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제381조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>철골 : </span>" +
              "<span class='font-normal'>추락방호망 및 안전대 부착설비가 적정하게 설치되어 있는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제43조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>철골 : </span>" +
              "<span class='font-normal'>작업 전 안전대 및 부속설비의 이상 유무를 점검하였는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제44조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>지붕 : </span>" +
              "<span class='font-normal'>강도가 약한 지붕 위에서 작업 시 폭이 30cm이상 되는 작업발판을 설치하였는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제45조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>지붕 : </span>" +
              "<span class='font-normal'>지붕 단부에 안전난간을 적정하게 설치하였는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제45조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-bold'>지붕 : </span>" +
              "<span class='font-normal'>안전난간을 설치하기 어려운 상태일 때 추락방호망을 적정하게 설치하였는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제45조)</span>",
            isChecked: "",
            title: "작업발판, 안전난간, 추락방호망",
          },
          {
            content: "<span class='font-normal'>안전난간, 울타리, 덮개 등 추락 방호조치를 적정하게 설치하였는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제43조)</span>",
            isChecked: "",
            title: "개구부 덮개·단부",
          },
          {
            content: "<span class='font-normal'>통로가 안전하게 사용될 수 있도록 유지되고 있는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제22조)</span>",
            isChecked: "",
            title: "안전통로 확보",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검자"].required) return "점검자를 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
